import { render } from "./SeeDetailUser.vue?vue&type=template&id=01b2a759"
import script from "./SeeDetailUser.vue?vue&type=script&lang=js"
export * from "./SeeDetailUser.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\2. Fabrica 2022\\Proyecto_Andres_Fabrica\\proyecto_llaves\\version_principal\\frontend_proyecto_llaves\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__